export default __webpack_public_path__ + "static/media/expo1.07dc31a6.jpg";